module.exports = __webpack_public_path__ + "media/application/images/svgs/map-623930579c824e5146aaa0c850118608.svg";